import Vue from 'vue'
import { Button,Menu,Dropdown,DropdownMenu,DropdownItem,Carousel, CarouselItem,Input,Breadcrumb,
    BreadcrumbItem,Pagination,Tabs,TabPane,Message,Timeline,TimelineItem,Dialog,Image,Switch,Upload,Scrollbar,
    Table,TableColumn,Form,FormItem,MenuItemGroup,Col,Submenu,Row,MenuItem,Autocomplete,
    Select,Option,OptionGroup,Tree,Tag,Checkbox,CheckboxGroup,MessageBox,Card,ColorPicker
    } from 'element-ui'

Vue.use(Button)
Vue.use(Menu)
Vue.use(MenuItemGroup)
Vue.use(Col)

Vue.use(ColorPicker)

Vue.use(Card)

Vue.use(Submenu)
Vue.use(Row)
Vue.use(MenuItem)
Vue.use(Autocomplete)
Vue.use(Dialog)

Vue.use(Scrollbar)


Vue.use(Tree)

Vue.use(Tag)

Vue.use(Upload)

Vue.use(Image)
Vue.use(Switch)

Vue.use(Checkbox)
Vue.use(CheckboxGroup)

Vue.use(Option)
Vue.use(OptionGroup)

Vue.use(Select)

// Vue.use(ScrollBar)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)

Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)

Vue.use(Tabs)
Vue.use(TabPane)

// Vue.use(Message)

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)

Vue.use(Timeline)
Vue.use(TimelineItem)

Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.prototype.$message = Message;